import React, { useEffect, useState } from "react";
import { Button, Container, Row } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import OTPInput from "react-otp-input";

import Header from "../Layout/header";
import Footer from "../Layout/footer";
import { FaArrowRight } from "react-icons/fa6";
import logocircle from "../Assets/logo-circle2.png";
import newsletter from "../Assets/newsletter-image3.png";
import config from "../helper/config";
import { ImgEmpty, ImgUrl, MinuteHourFormat, isEmpty } from "../helper/common";
import { GetuserData, KYCInputGet, KycSubmit, userLogin } from "../Axios/user.axios";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import Subscriber from "../Layout/subscribe";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import Select from "react-select";
import "react-phone-number-input/style.css";
import Webcam from "react-webcam";
import { useRef } from "react";
import { useCallback } from "react";
import profileCover from '../Assets/profilecover.png'


const initform = {
  UserName: "",
  EmailId: "",
  // Mobile: "",
  Password: "",
  ConfirmPassword: "",
  TermsandConditions: false,
};

const initinputfield = {
  "PersonalDetailsFields": [
    {
      "InputType": "input",
      "FieldName": "First Name",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "FirstName"
    },
    {
      "InputType": "input",
      "FieldName": "Middle Name",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "MiddleName"
    },
    {
      "InputType": "input",
      "FieldName": "Last Name",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "LastName"
    },
    {
      "InputType": "input",
      "FieldName": "Date Of Birth",
      "Required": true,
      "label": "Date-Of-Birth",
      "type": "date",
      "value": "date-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "DateOf Birth"
    },
    {
      "InputType": "select",
      "FieldName": "Gender",
      "Required": true,
      "label": "Select Dropdown",
      "value": "select",
      "tagname": "select",
      "FirstKey": "Select",
      "Options": [
        {
          "name": "Male"
        },
        {
          "name": "Female"
        }
      ],
      "id": "Gender"
    },
    {
      "InputType": "input",
      "FieldName": "Email-Id",
      "Required": true,
      "label": "Text-Box",
      "type": "email",
      "value": "email-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "Email-Id"
    },
    {
      "InputType": "PhoneInput",
      "FieldName": "Phone Number",
      "Required": true,
      "label": "Mobile-Input",
      "value": "PhoneInput",
      "tagname": "PhoneInput",
      "FirstKey": "Enter",
      "id": "PhoneNumber"
    }
  ],
  "PhysicalAddressFields": [
    {
      "InputType": "input",
      "FieldName": "Address Line 1",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "AddressLine1"
    },
    {
      "InputType": "input",
      "FieldName": "Address Line 2",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "AddressLine2"
    },
    {
      "InputType": "input",
      "FieldName": "City",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "City"
    },
    {
      "InputType": "input",
      "FieldName": "State",
      "Required": true,
      "label": "Date-Of-Birth",
      "type": "dob",
      "value": "dob-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "State"
    },
    {
      "InputType": "input",
      "FieldName": "Country",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "Country"
    },
    {
      "InputType": "input",
      "FieldName": "ZipCode",
      "Required": true,
      "label": "Text-Box",
      "type": "text",
      "value": "text-input",
      "tagname": "input",
      "FirstKey": "Enter",
      "id": "ZipCode"
    }
  ],
  "BioMetricFields": [
    {
      "InputType": "input",
      "FieldName": "Address Proof Front",
      "Required": true,
      "label": "File Upload",
      "type": "file",
      "value": "file-input",
      "accept" : "image/*",
      "tagname": "input",
      "FirstKey": "Upload",
      "id": "AddressProofFront"
    },
    {
      "InputType": "input",
      "FieldName": "Address Proof Back",
      "Required": true,
      "label": "File Upload",
      "type": "file",
      "value": "file-input",
      "accept" : "image/*",
      "tagname": "input",
      "FirstKey": "Upload",
      "id": "AddressProofBack"
    },
    {
      "InputType": "input",
      "FieldName": "National Id Front",
      "Required": true,
      "label": "File Upload",
      "type": "file",
      "value": "file-input",
      "accept" : "image/*",
      "tagname": "input",
      "FirstKey": "Upload",
      "id": "NationalIdFront"
    },
    {
      "InputType": "input",
      "FieldName": "National Id Back",
      "Required": true,
      "label": "File Upload",
      "type": "file",
      "value": "file-input",
      "accept" : "image/*",
      "tagname": "input",
      "FirstKey": "Upload",
      "id": "NationalIdBack"
    },
    {
      "InputType": "Webcam",
      "FieldName": "Face Image",
      "Required": true,
      "label": "Live Image",
      "type": "Webcam",
      "value": "Webcam-Webcam",
      "tagname": "Webcam",
      "FirstKey": "Capture",
      "id": "FaceImage"
    },
  ],
}

const initname = {
  UserName: "User Name",
  EmailId: "Email-Id",
  // Mobile: "",
  Password: "Password",
  ConfirmPassword: "Confirm Password",
  TermsandConditions: "The Term and Policy must be accepted.",
};

const GenderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
]

export default function KycVerification() {
  const navigate = useNavigate();

  const webcamRef = useRef(null);


  const [focusedfield, SetFocusedField] = useState([]);

  const [img, setImg] = useState(null);
  const [formValue, setFormValue] = useState(initform);
  const [disablebtn, setDisablebtn] = useState(0);
  const [Error, SetError] = useState({});
  const [RefreshData, SetRefreshData] = useState(1);
  const [user, setUser] = useState();

  const [passwordType, setPasswordType] = useState("password");
  const [passwordType1, setPasswordType1] = useState("password");

  const [step, setStep] = useState(1);

  const [InputFields, SetInputFields] = useState(initinputfield)

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const togglePassword1 = () => {
    if (passwordType1 === "password") {
      setPasswordType1("text");
      return;
    }
    setPasswordType1("password");
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const OnChange = (e, name, type) => {
    setDisablebtn(0);
    if (name) {
      SetError({ ...Error, ...{ [name]: '' } })
      let formData = {
        ...formValue,
        ...{
          [type]: {
            ...formValue?.[type],
            [name]: e?.value ? e?.value : e,
          }
        }
      };
      return setFormValue(formData);
    }
    const { id, value } = e.target;
    name = e?.target?.name;
    SetError({ ...Error, ...{ [id]: '' } })
    let formData = {
      ...formValue,
      ...{
        [name]: {
          ...formValue?.[name],
          [id]: value,
        },
      }
    };
    setFormValue(formData);
  };

  const handleFile = (event) => {
    setDisablebtn(0);
    event.preventDefault();
    const { id, files, name } = event.target;
    console.log('files[0]-->',files[0],files[0].type.includes('image'))
    if(files[0].type.includes('image')){
    setDisablebtn(0);
    SetError({ ...Error, ...{ [id]: '' } })
    let formData = {
      ...formValue,
      ...{
        BioMetric: {
          ...formValue?.BioMetric,
          ...{
            [id]: files[0],
          },
        }
      }
    };
    setFormValue(formData);
    }
    
  };

  const Register = async (from) => {
    let errorcheck = await Validate(formValue);
    if (isEmpty(errorcheck)) {
      SetError({})
      if (from == 'next') {
        setStep(step < 3 ? step + 1 : 3);
      }
      else {
        let senddata = {};
        senddata = {
          ...formValue?.[formValue?.type],
          type: formValue?.type,
        }
        let resp = await KycSubmit(senddata);
        console.log('KycSubmit_resp', resp)
        if (resp?.success == 'success') {
          setDisablebtn(3);
          setDisablebtn(0);
          toast.success("Updated Successfully");
          setStep(step < 3 ? step + 1 : 3);
          // setTimeout(() => navigate("/my-items"), 1000);
          SetError({})
          SetRefreshData(RefreshData + 1)
          if(from == "submit"){
          navigate('/profile')

          }
        }
        else {
          setDisablebtn(1);
          if (resp?.data) {
            SetError(resp?.data);
          }
          toast.error((resp?.msg ? resp?.msg : "Try Again"),);
        }
      }
    }
    else {
      setDisablebtn(1);
      SetError(errorcheck);
      toast.error("Fix all Validations", 1000)
    }
  };


  useEffect(() => {
    let cookie = ("; " + document.cookie)
      .split(`; ${config.cookiename}=`)
      .pop()
      .split(";")[0];
    if (cookie) {
      getProfiledata(cookie);
    }
    else {
      // navigate('/login')
    }
  }, [RefreshData])

  async function getProfiledata(cookie) {
    setDisablebtn(0);
    var data = await GetuserData({ data: cookie });
    console.log('GetuserData_resp', data)
    if (data?.status) {
      setUser(data?.data)
      if (data?.data) {
        setFormValue({ ...(data?.data?.kycdata ? data?.data?.kycdata : {}), type: "PersonalDetails" })
        let inputfields = await KYCInputGet({ action: 'get' });
        console.log('KYCInputGet_resp', inputfields)
        SetInputFields(inputfields?.data)
      }
    }
    else {
      // navigate('/login')
    }
  }

  const OnBlurFn = async (e, id, type) => {
    if (isEmpty(id)) {
      id = e?.target?.id
    }
    let value = e?.target?.value ? e?.target?.value : (e?.value ? e?.value : e)
    // const { id, value } = e.target;
    let error = await Validate(formValue);
    Object.keys(error).map((currkey) => {
      if (currkey == id || focusedfield.includes(currkey)) {
      } else {
        delete error[currkey];
      }
    });
    if (focusedfield?.includes(id)) {
    } else {
      SetFocusedField([...focusedfield, ...[id]]);
    }
    SetError(error);
  };

  const [fileFront, setFileFront] = useState();
  const [fileBack, setFileBack] = useState();

  function handleFrontImg(e) {
    setFileFront(URL.createObjectURL(e.target.files[0]));
  }
  function handleBackImg(e) {
    setFileBack(URL.createObjectURL(e.target.files[0]));
  }

  const handleStep = (val) => {
    setStep(step + 1);
  };

  const GoBack = () => {
    if (step <= 1) {
      return setStep(1);
    }
    setStep(step - 1);
  };

  const Validate = async (data) => {
    var validateError = {};
    let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([A-Za-zA-Z\-0-9]+\.)+[A-Za-zA-Z]{2,}))$/;
    let imageSize = 5000000;
    data.type = (step <= 1 ? "PersonalDetails" : (step == 2 ? "PhysicalAddress" : "BioMetric"));
    if (isEmpty(data?.type)) {
      validateError.type = "Select Type";
    }
    else {
      if (data?.type == 'PersonalDetails') {
        InputFields.PersonalDetailsFields.map((val) => {
          if (val?.Required) {
            if (val?.type != 'file' && val?.type != 'Webcam') {
              if (isEmpty(data?.PersonalDetails?.[val.id])) {
                validateError[val.id] = val.FieldName + " is Required";
              }
              else if (val.InputType == 'PhoneInput' && !isValidPhoneNumber(data?.PersonalDetails?.[val.id])) {
                validateError[val.id] = "Enter Valid Mobile Number";
              }
              else if (val.type == 'email' && !emailRegex.test(data?.PersonalDetails?.[val.id])) {
                validateError[val.id] = "Enter Valid Email-Id";
              }
            }
            else {
              if (ImgEmpty(data?.PersonalDetails?.[val.id])) {
                validateError[val.id] = [val.FieldName] + " is Required";
              }
              else if (typeof (data?.[data?.type]?.[val?.id]) == 'object') {
                if (imageSize < data?.[data?.type]?.[val?.id]?.size) {
                  validateError[val.id] = "File size must be below 5mb";
                }
                if (
                  !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
                    data?.[data?.type]?.[val?.id]?.name
                  )
                ) {
                  validateError[val.id] =
                    "file is invalid. only allowed JPG,PNG,WEBP,gif";
                }
              }
            }
          }
        })
        // if (isEmpty(data?.[data?.type]?.FirstName)) {
        //   validateError.FirstName = "First Name is Required";
        // }
        // else {
        //   if (config.nameFormat.test(data?.[data?.type]?.FirstName)) {
        //     validateError.FirstName = "Cannot allowed smiley";
        //   }
        // }
        // if (isEmpty(data?.[data?.type]?.MiddleName)) {
        //   validateError.MiddleName = "Middle Name is Required";
        // }
        // else {
        //   if (config.nameFormat.test(data?.[data?.type]?.MiddleName)) {
        //     validateError.MiddleName = "Cannot allowed smiley";
        //   }
        // }
        // if (isEmpty(data?.[data?.type]?.LastName)) {
        //   validateError.LastName = "Last Name is Required";
        // }
        // else {
        //   if (config.nameFormat.test(data?.[data?.type]?.LastName)) {
        //     validateError.LastName = "Cannot allowed smiley";
        //   }
        // }
        // if (isEmpty(data?.[data?.type]?.Gender)) {
        //   validateError.Gender = "Gender is Required";
        // }
        // if (isEmpty(data?.[data?.type]?.DOB)) {
        //   validateError.DOB = "Dat of Birth is Required";
        // }
        // if (isEmpty(data?.[data?.type]?.EmailId)) {
        //   validateError.EmailId = "Email-Id is Required";
        // }
        // else {
        //   if (!emailRegex.test(data?.[data?.type]?.EmailId)) {
        //     validateError.EmailId = "Enter valid Email-Id";
        //   }
        // }
        // if (isEmpty(data?.[data?.type]?.Mobile)) {
        //   validateError.Mobile = "Mobile Number is Required";
        // }
        // else if (!isValidPhoneNumber(data?.[data?.type]?.Mobile)) {
        //   validateError.Mobile = "Mobile Number is Required";
        // }
      }
      else if (data?.type == 'PhysicalAddress') {
        InputFields.PhysicalAddressFields.map((val) => {
          if (val?.Required) {
            if (val?.type != 'file' && val?.type != 'Webcam') {
              if (isEmpty(data?.PhysicalAddress?.[val.id])) {
                validateError[val.id] = val.FieldName + " is Required";
              }
              else if (val.InputType == 'PhoneInput' && !isValidPhoneNumber(data?.PhysicalAddress?.[val.id])) {
                validateError[val.id] = "Enter Valid Mobile Number";
              }
              else if (val.type == 'email' && !emailRegex.test(data?.PhysicalAddress?.[val.id])) {
                validateError[val.id] = "Enter Valid Email-Id";
              }
            }
            else {
              if (ImgEmpty(data?.PhysicalAddress?.[val.id])) {
                validateError[val.id] = [val.FieldName] + " is Required";
              }
              else if (typeof (data?.[data?.type]?.[val?.id]) == 'object') {
                if (imageSize < data?.[data?.type]?.[val?.id]?.size) {
                  validateError[val.id] = "File size must be below 5mb";
                }
                if (
                  !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
                    data?.[data?.type]?.[val?.id]?.name
                  )
                ) {
                  validateError[val.id] =
                    "file is invalid. only allowed JPG,PNG,WEBP,gif";
                }
              }
            }
          }
        })
        // if (isEmpty(data?.[data?.type]?.AddressLine1)) {
        //   validateError.AddressLine1 = "Address Line 1 is Required";
        // }
        // if (isEmpty(data?.[data?.type]?.AddressLine2)) {
        //   validateError.AddressLine2 = "Address Line 2 is Required";
        // }
        // if (isEmpty(data?.[data?.type]?.City)) {
        //   validateError.City = "City is Required";
        // }
        // if (isEmpty(data?.[data?.type]?.State)) {
        //   validateError.State = "State is Required";
        // }
        // if (isEmpty(data?.[data?.type]?.Country)) {
        //   validateError.Country = "Country is Required";
        // }
        // if (isEmpty(data?.[data?.type]?.ZipCode)) {
        //   validateError.ZipCode = "ZipCode is Required";
        // }
      }
      else if (data?.type == 'BioMetric') {
        InputFields.BioMetricFields.map((val) => {
          if (val?.Required) {
            if (val?.type != 'file' && val?.type != 'Webcam') {
              if (isEmpty(data?.BioMetric?.[val.id])) {
                validateError[val.id] = val.FieldName + " is Required";
              }
              else if (val.InputType == 'PhoneInput' && !isValidPhoneNumber(data?.BioMetric?.[val.id])) {
                validateError[val.id] = "Enter Valid Mobile Number";
              }
              else if (val.type == 'email' && !emailRegex.test(data?.BioMetric?.[val.id])) {
                validateError[val.id] = "Enter Valid Email-Id";
              }
            }
            else {
              if (ImgEmpty(data?.BioMetric?.[val.id])) {
                validateError[val.id] = [val.FieldName] + " is Required";
              }
              else if (typeof (data?.[data?.type]?.[val?.id]) == 'object') {
                if (imageSize < data?.[data?.type]?.[val?.id]?.size) {
                  validateError[val.id] = "File size must be below 5mb";
                }
                if (
                  !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
                    data?.[data?.type]?.[val?.id]?.name
                  )
                ) {
                  validateError[val.id] =
                    "file is invalid. only allowed JPG,PNG,WEBP,gif";
                }
              }
            }
          }
        })
        // console.log('fronttttttt',ImgEmpty(data?.[data?.type]?.AddressProof?.Front),data?.[data?.type]?.AddressProof?.Front)
        // if (ImgEmpty(data?.[data?.type]?.AddressProofFront)) {
        //   validateError.AddressProofFront = "Address Proof is Required";
        // }
        // else if (typeof (data?.[data?.type]?.AddressProofFront) == 'object') {
        //   if (imageSize < data?.[data?.type]?.AddressProofFront?.size) {
        //     validateError.AddressProofFront = "File size must be below 5mb";
        //   }
        //   if (
        //     !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
        //       data?.[data?.type]?.AddressProofFront?.name
        //     )
        //   ) {
        //     validateError.AddressProofFront =
        //       "file is invalid. only allowed JPG,PNG,WEBP,gif";
        //   }
        // }
        // if (ImgEmpty(data?.[data?.type]?.AddressProofBack)) {
        //   validateError.AddressProofBack = "Address Proof is Required";
        // }
        // else if (typeof (data?.[data?.type]?.AddressProofBack) == 'object') {
        //   if (imageSize < data?.[data?.type]?.AddressProofBack?.size) {
        //     validateError.AddressProofBack = "File size must be below 5mb";
        //   }
        //   if (
        //     !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
        //       data?.[data?.type]?.AddressProofBack?.name
        //     )
        //   ) {
        //     validateError.AddressProofBack =
        //       "file is invalid. only allowed JPG,PNG,WEBP,gif";
        //   }
        // }
        // if (ImgEmpty(data?.[data?.type]?.NationalIdFront)) {
        //   validateError.NationalIdFront = "National Id is Required";
        // }
        // else if (typeof (data?.[data?.type]?.NationalIdFront) == 'object') {
        //   if (imageSize < data?.[data?.type]?.NationalIdFront?.size) {
        //     validateError.NationalIdFront = "File size must be below 5mb";
        //   }
        //   if (
        //     !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
        //       data?.[data?.type]?.NationalIdFront?.name
        //     )
        //   ) {
        //     validateError.NationalIdFront =
        //       "file is invalid. only allowed JPG,PNG,WEBP,gif";
        //   }
        // }
        // if (ImgEmpty(data?.[data?.type]?.NationalIdBack)) {
        //   validateError.NationalIdBack = "National Id is Required";
        // }
        // else if (typeof (data?.[data?.type]?.NationalIdBack) == 'object') {
        //   if (imageSize < data?.[data?.type]?.NationalIdBack?.size) {
        //     validateError.NationalIdBack = "File size must be below 5mb";
        //   }
        //   if (
        //     !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
        //       data?.[data?.type]?.NationalIdBack.name
        //     )
        //   ) {
        //     validateError.NationalIdBack =
        //       "file is invalid. only allowed JPG,PNG,WEBP,gif";
        //   }
        // }
      }
      else {
        validateError.type = "Invalid Type";
      }
    }
    return validateError;
  };

  const GetKey = () => {
    if (step <= 1) {
      return 'PersonalDetailsFields'
    }
    if (step == 2) {
      return 'PhysicalAddressFields'
    }
    if (step >= 3) {
      return 'BioMetricFields'
    }
  }

  const capture = (buffer, id, type) => {
    SetError({})
    fetch(buffer).then(res => res.blob()).then(blob => {
      const file = new File([blob], 'image.webp', { type: blob.type })

      setFormValue({
        ...formValue,
        ...{
          [type]: {
            ...formValue?.[type],
            [id]: file,
          }
        }
      });
    })
  };

  const videoConstraints = {
    width: 390,
    height: 390,
    facingMode: "user",
  };

  return (
    <>
      <div className="register">
        <Header />

        <section className="section kyc_verification">
          <div className="container font-md">
            <section className="section box-page-register">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="box-steps-small">
                      <div
                        className={
                          step == 1 || step == 2 || step == 3
                            ? "item-number hover-up active"
                            : "item-number hover-up"
                        }
                      >
                        <div className="num-ele">1</div>
                        <div className="info-num">
                          <h5 className="color-brand-1 mb-15">
                            Personal Details
                          </h5>
                          <p className="font-md color-grey-500">
                            Fill your personal information
                          </p>
                        </div>
                      </div>

                      <div
                        className={
                          step == 2 || step == 3
                            ? "item-number hover-up active"
                            : "item-number hover-up"
                        }
                      >
                        <div className="num-ele">2</div>
                        <div className="info-num">
                          <h5 className="color-brand-1 mb-15">
                            Address Details
                          </h5>
                          <p className="font-md color-grey-500">
                            Fill your address details
                          </p>
                        </div>
                      </div>

                      <div
                        className={
                          step == 3
                            ? "item-number hover-up active"
                            : "item-number hover-up"
                        }
                      >
                        <div className="num-ele">3</div>
                        <div className="info-num">
                          <h5 className="color-brand-1 mb-15">
                            Proof Updation
                          </h5>
                          <p className="font-md color-grey-500">
                            Upload your identity documents
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {step == 1 && (
                    <div className="col-lg-8">
                      <div className="box-register">
                        <h2 className="color-brand-1 mb-15">
                          Personal Details
                        </h2>
                        <p className="font-md color-grey-500 mb-4">
                          Fill your personal information
                        </p>

                        <form className="row" action="" novalidate="novalidate">

                          {
                            InputFields?.PersonalDetailsFields?.map((val, ind) => {
                              return (
                                <>
                                  {
                                    val?.InputType == 'input' ?
                                      (val?.type != "file" ?
                                        <div className="col-lg-12 col-sm-12">
                                          <div className="form-group mb-4">
                                            <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                            <input
                                              className={
                                                focusedfield?.includes(val?.id)
                                                  ? Error?.[val?.id]
                                                    ? "form-control icon-name is-invalid"
                                                    : "form-control icon-name is-valid"
                                                  : `form-control ${val?.type == 'date' ? 'date_class' : ''} ${val?.type == 'email' ? 'icon-email' : 'icon-name'}`
                                              }
                                              type={val?.type}
                                              name="PersonalDetails"
                                              placeholder={(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}
                                              onChange={(e) => OnChange(e)}
                                              onBlur={(e) => OnBlurFn(e)}
                                              id={val?.id}
                                              value={formValue?.PersonalDetails?.[val?.id] || ""}
                                              max={`${MinuteHourFormat(new Date().getFullYear())}-${MinuteHourFormat(new Date().getMonth() + 1)}-${MinuteHourFormat(new Date().getDate())}`}
                                            />
                                            {Error?.[val?.id] && (
                                              <span className="error-msg">
                                                {Error[val?.id]}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        :
                                        <>
                                          <div className="col-lg-6 col-sm-6 col-md-6">
                                            <div className="form-group mb-3">
                                              <label className="uploadLabel mb-2">
                                                {val.FieldName}
                                              </label>
                                              <div className="custom_uploadBtn">
                                                <input
                                                  id={val?.id}
                                                  name="Front"
                                                  type="file"
                                                  onChange={handleFile}
                                                ></input>
                                                {Error?.[val?.id] && (
                                                  <span className="error-msg">
                                                    {Error?.[val?.id]}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            {formValue?.PersonalDetails?.[val?.id] ?
                                              (
                                                <>
                                                  <p className="uploadLabel mb-2">Preview</p>
                                                  <div className="upload_PreviewImg">
                                                    <img
                                                      src={
                                                        typeof (formValue?.PersonalDetails?.[val?.id]) == 'string'
                                                          ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.PersonalDetails?.[val?.id]}`
                                                          : ImgUrl(formValue?.PersonalDetails?.[val?.id])
                                                      }
                                                      alt="img"
                                                      className="img-fluid"
                                                    />
                                                  </div>
                                                </>
                                              )
                                              :
                                              <></>
                                            }
                                          </div>
                                        </>
                                      )
                                      :
                                      (val?.InputType == 'select'
                                        ?
                                        <div className="col-lg-12 col-sm-12">
                                          <div className="form-group mb-4">
                                            <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                            <Select
                                              options={val.Options}
                                              onChange={(e) => OnChange(e, val?.id, "PersonalDetails")}
                                              value={
                                                isEmpty(formValue?.PersonalDetails?.[val?.id])
                                                  ?
                                                  {
                                                    label: "Select " + val?.FieldName,
                                                    value: "Select " + val?.FieldName,
                                                  }
                                                  :
                                                  {
                                                    label: formValue?.PersonalDetails?.[val?.id],
                                                    value: formValue?.PersonalDetails?.[val?.id],
                                                  }
                                              }
                                            />
                                            {Error?.[val?.id] && (
                                              <span className="error-msg">
                                                {Error[val?.id]}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        :
                                        (
                                          val?.InputType == "PhoneInput"
                                            ?
                                            <div className="col-lg-12 col-sm-12">
                                              <div className="form-group mb-4">
                                                <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                                <PhoneInput
                                                  placeholder={(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}
                                                  id={val?.id}
                                                  className={
                                                   `phoneInputCom ${focusedfield?.includes(val?.id)
                                                      ? Error?.[val?.id]
                                                        ? "form-control icon-name is-invalid"
                                                        : "form-control icon-name is-valid"
                                                      : "form-control icon-name"}`
                                                  }
                                                  onChange={(e) => OnChange(e, val?.id, "PersonalDetails")}
                                                  // defaultCountry="US"
                                                  // country="US"
                                                  // countries={["US", "IN"]}
                                                  onBlur={(e) => OnBlurFn(e, val?.id, "PersonalDetails")}
                                                  value={formValue?.PersonalDetails?.[val?.id] ?? ''}
                                                />
                                                {Error?.[val?.id] && (
                                                  <span className="error-msg">
                                                    {Error[val?.id]}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            :
                                            (
                                              val?.InputType == 'Webcam'
                                                ?
                                                <>

                                                  <div className="col-lg-6 col-sm-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                      <label className="uploadLabel mb-2">
                                                        {val.FieldName}
                                                      </label>
                                                      <div className="custom_uploadBtn">
                                                        {
                                                          formValue?.PersonalDetails?.[val?.id]
                                                            ?
                                                            <>
                                                              <button
                                                                onClick={() => {
                                                                  setFormValue({
                                                                    ...formValue,
                                                                    ...{
                                                                      PersonalDetails: {
                                                                        ...formValue?.PersonalDetails,
                                                                        [val?.id]: null,
                                                                      }
                                                                    }
                                                                  });
                                                                }}
                                                              >
                                                                Recapture
                                                              </button>
                                                            </>
                                                            :
                                                            <>
                                                              <Webcam
                                                                id={"PersonalDetails" + val?.id + String(ind)}
                                                                screenshotFormat="image/jpeg"
                                                                videoConstraints={videoConstraints}
                                                                audio={false}
                                                                height={500}
                                                                width={500}
                                                                mirrored={true}
                                                              >
                                                                {({ getScreenshot }) => (
                                                                  <button
                                                                    onClick={() => {
                                                                      const imageSrc = getScreenshot();
                                                                      capture(imageSrc, val?.id, "PersonalDetails");
                                                                    }}
                                                                  >
                                                                    Capture photo
                                                                  </button>
                                                                )}
                                                              </Webcam>
                                                            </>
                                                        }
                                                        {Error?.[val?.id] && (
                                                          <span className="error-msg">
                                                            {Error?.[val?.id]}
                                                          </span>
                                                        )}
                                                      </div>
                                                    </div>
                                                    {formValue?.PersonalDetails?.[val?.id] ?
                                                      (
                                                        <>
                                                          <p className="uploadLabel mb-2">Preview</p>
                                                          <div className="upload_PreviewImg">
                                                            <img
                                                              src={
                                                                typeof (formValue?.PersonalDetails?.[val?.id]) == 'string'
                                                                  ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.PersonalDetails?.[val?.id]}`
                                                                  : ImgUrl(formValue?.PersonalDetails?.[val?.id])
                                                              }
                                                              alt="img"
                                                              className="img-fluid"
                                                            />
                                                          </div>
                                                        </>
                                                      )
                                                      :
                                                      <></>
                                                    }
                                                  </div>
                                                </>
                                                :
                                                <></>
                                            )
                                        )
                                      )
                                  }
                                </>
                              )
                            })
                          }

                          {/* 
                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("FirstName")
                                    ? Error?.FirstName
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PersonalDetails"
                                placeholder="First Name"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="FirstName"
                                value={formValue?.PersonalDetails?.FirstName || ""}
                              />
                              {Error?.FirstName && (
                                <span className="error-msg">
                                  {Error.FirstName}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("MiddleName")
                                    ? Error?.MiddleName
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PersonalDetails"
                                placeholder="Middle Name"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="MiddleName"
                                value={formValue?.PersonalDetails?.MiddleName || ""}
                              />
                              {Error?.MiddleName && (
                                <span className="error-msg">
                                  {Error.MiddleName}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("LastName")
                                    ? Error?.LastName
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PersonalDetails"
                                placeholder="Last Name"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="LastName"
                                value={formValue?.PersonalDetails?.LastName || ""}
                              />
                              {Error?.LastName && (
                                <span className="error-msg">
                                  {Error.LastName}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("DOB")
                                    ? Error?.DOB
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="date"
                                name="PersonalDetails"
                                placeholder="Date of Birth"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="DOB"
                                value={formValue?.PersonalDetails?.DOB || ""}
                              />
                              {Error?.DOB && (
                                <span className="error-msg">
                                  {Error.DOB}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <Select
                                options={GenderOptions}
                                onChange={(e)=>OnChange(e,"Gender","PersonalDetails")}
                                value={
                                  isEmpty(formValue?.PersonalDetails?.Gender)
                                  ?
                                  {
                                    label: "Select Gender",
                                    value: "Select Gender",
                                  }
                                  :
                                  {
                                    label: formValue?.PersonalDetails?.Gender,
                                    value: formValue?.PersonalDetails?.Gender,
                                  }
                                }
                              />
                              {Error?.Gender && (
                                <span className="error-msg">
                                  {Error.Gender}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("EmailId")
                                    ? Error?.EmailId
                                      ? "form-control icon-email is-invalid"
                                      : "form-control icon-email is-valid"
                                    : "form-control icon-email"
                                }
                                type="email"
                                name="EmailId"
                                placeholder="Your email"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="EmailId"
                                value={formValue?.PersonalDetails?.EmailId || ""}
                              />
                              {Error?.EmailId && (
                                <span className="error-msg">
                                  {Error.EmailId}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <PhoneInput
                                placeholder="Enter phone number"
                                id="Mobile"
                                className={
                                  focusedfield?.includes("Mobile")
                                    ? Error?.Mobile
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                onChange={(e) => OnChange(e, "Mobile", "PersonalDetails")}
                                defaultCountry="US"
                                country="US"
                                countries={["US", "IN"]}
                                value={formValue?.PersonalDetails?.Mobile ?? ''}
                              />
                              {Error?.Mobile && (
                                <span className="error-msg">
                                  {Error.Mobile}
                                </span>
                              )}
                            </div>
                          </div> 
                          */}
                          {
                            isEmpty(formValue?.PersonalDetailsReject)
                              ?
                              <></>
                              :
                              <div className="col-lg-12 col-sm-12">
                                <div className="form-group mb-4">
                                  <label>Reason for Rejection</label>
                                  <input
                                    className={"form-control icon-email is-invalid"}
                                    type="text"
                                    name="PersonalDetailsReject"
                                    placeholder="Your email"
                                    disabled={true}
                                    id="PersonalDetailsReject"
                                    value={formValue?.PersonalDetailsReject || ""}
                                  />
                                </div>
                              </div>
                          }

                          <div className="row align-items-center mt-30 ">
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                              <div className="form-group">
                                <button
                                  className="btn btn-brand-lg btn-full font-md-bold"
                                  type="button"
                                  onClick={() => Register()}
                                // onClick={() => handleStep(step)}
                                >
                                  Save & Next
                                </button>
                              </div>
                            </div>
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                              <div className="form-group">
                                <button
                                  className="btn btn-brand-lg btn-full font-md-bold"
                                  type="button"
                                  onClick={() => Register('next')}
                                // onClick={() => handleStep(step)}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}
                  {step == 2 && (
                    <div className="col-lg-8">
                      <div className="box-register">
                        <h2 className="color-brand-1 mb-15">Address Details</h2>
                        <p className="font-md color-grey-500 mb-4">
                          Fill your address details
                        </p>

                        <form className="row" action="" novalidate="novalidate">

                          {
                            InputFields?.PhysicalAddressFields?.map((val, ind) => {
                              return (
                                <>
                                  {
                                    val?.InputType == 'input' ?

                                      (val?.type != "file" ?
                                        <div className="col-lg-12 col-sm-12">
                                          <div className="form-group mb-4">
                                            <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                            <input
                                              className={
                                                focusedfield?.includes(val?.id)
                                                  ? Error?.[val?.id]
                                                    ? "form-control icon-name is-invalid"
                                                    : "form-control icon-name is-valid"
                                                  : "form-control icon-name"
                                              }
                                              type={val?.type}
                                              name="PhysicalAddress"
                                              placeholder={(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}
                                              onChange={(e) => OnChange(e)}
                                              onBlur={(e) => OnBlurFn(e)}
                                              id={val?.id}
                                              value={formValue?.PhysicalAddress?.[val?.id] || ""}
                                              max={`${MinuteHourFormat(new Date().getFullYear())}-${MinuteHourFormat(new Date().getMonth() + 1)}-${MinuteHourFormat(new Date().getDate())}`}
                                            />
                                            {Error?.[val?.id] && (
                                              <span className="error-msg">
                                                {Error[val?.id]}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        :
                                        <>
                                          <div className="col-lg-6 col-sm-6 col-md-6">
                                            <div className="form-group mb-3">
                                              <label className="uploadLabel mb-2">
                                                {val.FieldName}
                                              </label>
                                              <div className="custom_uploadBtn">
                                                <input
                                                  id={val?.id}
                                                  name="Front"
                                                  type="file"
                                                  onChange={handleFile}
                                                ></input>
                                                {Error?.[val?.id] && (
                                                  <span className="error-msg">
                                                    {Error?.[val?.id]}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            {formValue?.PhysicalAddress?.[val?.id] ?
                                              (
                                                <>
                                                  <p className="uploadLabel mb-2">Preview</p>
                                                  <div className="upload_PreviewImg">
                                                    <img
                                                      src={
                                                        typeof (formValue?.PhysicalAddress?.[val?.id]) == 'string'
                                                          ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.PhysicalAddress?.[val?.id]}`
                                                          : ImgUrl(formValue?.PhysicalAddress?.[val?.id])
                                                      }
                                                      alt="img"
                                                      className="img-fluid"
                                                    />
                                                  </div>
                                                </>
                                              )
                                              :
                                              <></>
                                            }
                                          </div>
                                        </>
                                      )
                                      :
                                      (val?.InputType == 'select'
                                        ?
                                        <div className="col-lg-12 col-sm-12">
                                          <div className="form-group mb-4">
                                            <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                            <Select
                                              options={val.Options}
                                              onChange={(e) => OnChange(e, val?.id, "PhysicalAddress")}
                                              value={
                                                isEmpty(formValue?.PhysicalAddress?.[val?.id])
                                                  ?
                                                  {
                                                    label: "Select " + val?.FieldName,
                                                    value: "Select " + val?.FieldName,
                                                  }
                                                  :
                                                  {
                                                    label: formValue?.PhysicalAddress?.[val?.id],
                                                    value: formValue?.PhysicalAddress?.[val?.id],
                                                  }
                                              }
                                            />
                                            {Error?.[val?.id] && (
                                              <span className="error-msg">
                                                {Error[val?.id]}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        :
                                        (
                                          val?.InputType == "PhoneInput"
                                            ?
                                            <div className="col-lg-12 col-sm-12">
                                              <div className="form-group mb-4">
                                                <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                                <PhoneInput
                                                  placeholder={(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}
                                                  id={val?.id}
                                                  className={
                                                    focusedfield?.includes(val?.id)
                                                      ? Error?.[val?.id]
                                                        ? "form-control icon-name is-invalid"
                                                        : "form-control icon-name is-valid"
                                                      : "form-control icon-name"
                                                  }
                                                  onChange={(e) => OnChange(e, val?.id, "PhysicalAddress")}
                                                  // defaultCountry="US"
                                                  // country="US"
                                                  // countries={["US", "IN"]}
                                                  onBlur={(e) => OnBlurFn(e, val?.id, "PhysicalAddress")}
                                                  value={formValue?.PhysicalAddress?.[val?.id] ?? ''}
                                                />
                                                {Error?.[val?.id] && (
                                                  <span className="error-msg">
                                                    {Error[val?.id]}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            :
                                            (val?.InputType == 'Webcam'
                                              ?
                                              <>

                                                <div className="col-lg-6 col-sm-6 col-md-6">
                                                  <div className="form-group mb-3">
                                                    <label className="uploadLabel mb-2">
                                                      {val.FieldName}
                                                    </label>
                                                    <div className="custom_uploadBtn">
                                                      {
                                                        formValue?.PhysicalAddress?.[val?.id]
                                                          ?
                                                          <>
                                                            <button
                                                              onClick={() => {
                                                                setFormValue({
                                                                  ...formValue,
                                                                  ...{
                                                                    PhysicalAddress: {
                                                                      ...formValue?.PhysicalAddress,
                                                                      [val?.id]: null,
                                                                    }
                                                                  }
                                                                });
                                                              }}
                                                            >
                                                              Recapture
                                                            </button>
                                                          </>
                                                          :
                                                          <>
                                                            <Webcam
                                                              id={"PhysicalAddress" + val?.id + String(ind)}
                                                              screenshotFormat="image/jpeg"
                                                              videoConstraints={videoConstraints}
                                                              audio={false}
                                                              height={500}
                                                              width={500}
                                                              mirrored={true}
                                                            >
                                                              {({ getScreenshot }) => (
                                                                <button
                                                                  onClick={() => {
                                                                    const imageSrc = getScreenshot();
                                                                    capture(imageSrc, val?.id, "PhysicalAddress");
                                                                  }}
                                                                >
                                                                  Capture photo
                                                                </button>
                                                              )}
                                                            </Webcam>
                                                          </>
                                                      }
                                                      {Error?.[val?.id] && (
                                                        <span className="error-msg">
                                                          {Error?.[val?.id]}
                                                        </span>
                                                      )}
                                                    </div>
                                                  </div>
                                                  {formValue?.PhysicalAddress?.[val?.id] ?
                                                    (
                                                      <>
                                                        <p className="uploadLabel mb-2">Preview</p>
                                                        <div className="upload_PreviewImg">
                                                          <img
                                                            src={
                                                              typeof (formValue?.PhysicalAddress?.[val?.id]) == 'string'
                                                                ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.PhysicalAddress?.[val?.id]}`
                                                                : ImgUrl(formValue?.PhysicalAddress?.[val?.id])
                                                            }
                                                            alt="img"
                                                            className="img-fluid"
                                                          />
                                                        </div>
                                                      </>
                                                    )
                                                    :
                                                    <></>
                                                  }
                                                </div>
                                              </>
                                              :
                                              <></>)
                                        )
                                      )
                                  }
                                </>
                              )
                            })
                          }

                          {/* <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("AddressLine2")
                                    ? Error?.AddressLine2
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PhysicalAddress"
                                placeholder="Address Line 2"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="AddressLine2"
                                value={formValue?.PhysicalAddress?.AddressLine2 || ""}
                              />
                              {Error?.AddressLine2 && (
                                <span className="error-msg">
                                  {Error.AddressLine2}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("City")
                                    ? Error?.City
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PhysicalAddress"
                                placeholder="City"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="City"
                                value={formValue?.PhysicalAddress?.City || ""}
                              />
                              {Error?.City && (
                                <span className="error-msg">
                                  {Error.City}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("State")
                                    ? Error?.State
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PhysicalAddress"
                                placeholder="State"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="State"
                                value={formValue?.PhysicalAddress?.State || ""}
                              />
                              {Error?.State && (
                                <span className="error-msg">
                                  {Error.State}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("Country")
                                    ? Error?.Country
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PhysicalAddress"
                                placeholder="Country"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="Country"
                                value={formValue?.PhysicalAddress?.Country || ""}
                              />
                              {Error?.Country && (
                                <span className="error-msg">
                                  {Error.Country}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 col-sm-12">
                            <div className="form-group mb-4">
                              <input
                                className={
                                  focusedfield?.includes("Pincode")
                                    ? Error?.ZipCode
                                      ? "form-control icon-name is-invalid"
                                      : "form-control icon-name is-valid"
                                    : "form-control icon-name"
                                }
                                type="text"
                                name="PhysicalAddress"
                                placeholder="ZipCode"
                                onChange={(e) => OnChange(e)}
                                onBlur={(e) => OnBlurFn(e)}
                                id="ZipCode"
                                value={formValue?.PhysicalAddress?.ZipCode || ""}
                              />
                              {Error?.ZipCode && (
                                <span className="error-msg">
                                  {Error.ZipCode}
                                </span>
                              )}
                            </div>
                          </div> */}

                          {
                            isEmpty(formValue?.PhysicalAddressReject)
                              ?
                              <></>
                              :
                              <div className="col-lg-12 col-sm-12">
                                <div className="form-group mb-4">
                                  <label>Reason for Rejection</label>
                                  <input
                                    className={"form-control icon-email is-invalid"}
                                    type="text"
                                    name="PhysicalAddressReject"
                                    placeholder="Your email"
                                    disabled={true}
                                    id="PhysicalAddressReject"
                                    value={formValue?.PhysicalAddressReject || ""}
                                  />
                                </div>
                              </div>
                          }

                          {/* <div className="row align-items-center mt-30 ">
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                              <div className="form-group">
                                <button
                                  className="btn btn-brand-lg btn-full font-md-bold"
                                  type="button"
                                  onClick={() => Register('next')}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                              <div className="form-group">
                                <button
                                  className="btn btn-brand-lg btn-full font-md-bold"
                                  type="button"
                                  onClick={() => Register()}
                                >
                                  Save & Next
                                </button>
                              </div>
                            </div>
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                              <div className="form-group">
                                <button
                                  className="btn btn-brand-lg btn-full font-md-bold"
                                  type="button"
                                  onClick={() => GoBack(step)}
                                >
                                  Back
                                </button>
                              </div>
                            </div>
                          </div> */}
                          <div className="d-flex flex-wrap align-items-center " style={{ gap: "20px" }}>
                            <button
                              className="btn btn-brand-lg btn-full font-md-bold btn_max_width"
                              type="button"
                              //   onClick={() => Register()}
                              onClick={() => GoBack(step)}
                            >
                              Back
                            </button>
                            <button
                              className="btn btn-brand-lg btn-full font-md-bold btn_max_width"
                              type="button"
                              onClick={() => Register()}
                            // onClick={() => handleStep(step)}
                            >
                              Save & Next
                            </button>
                            <button
                              className="btn btn-brand-lg btn-full font-md-bold btn_max_width"
                              type="button"
                              onClick={() => Register('next')}
                            // onClick={() => handleStep(step)}
                            >
                              Next
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}
                  {step == 3 && (
                    <div className="col-lg-8">
                      <div className="box-register">
                        <h2 className="color-brand-1 mb-15">Proof Updation</h2>
                        <p className="font-md color-grey-500 mb-4">
                          Upload your identity documents
                        </p>

                        <div className="row">

                          {
                            InputFields?.BioMetricFields?.map((val, ind) => {
                              return (
                                <>
                                  {
                                    val?.InputType == 'input' ?

                                      (val?.type != "file" ?
                                        <div className="col-lg-12 col-sm-12">
                                          <div className="form-group mb-4">
                                            <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                            <input
                                              className={
                                                focusedfield?.includes(val?.id)
                                                  ? Error?.[val?.id]
                                                    ? "form-control icon-name is-invalid"
                                                    : "form-control icon-name is-valid"
                                                  : "form-control icon-name"
                                              }
                                              type={val?.type}
                                              name="BioMetric"
                                              accept={val?.accept}
                                              placeholder={(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}
                                              onChange={(e) => OnChange(e)}
                                              onBlur={(e) => OnBlurFn(e)}
                                              id={val?.id}
                                              value={formValue?.BioMetric?.[val?.id] || ""}
                                              max={`${MinuteHourFormat(new Date().getFullYear())}-${MinuteHourFormat(new Date().getMonth() + 1)}-${MinuteHourFormat(new Date().getDate())}`}
                                            />
                                            {Error?.[val?.id] && (
                                              <span className="error-msg">
                                                {Error[val?.id]}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        :
                                        <>
                                          {/* <div className="col-12">
                                            <p className="font-md color-grey-500 mb-4">
                                              1.) Address Proof
                                            </p>
                                          </div> */}
                                          <div className="col-lg-6 col-sm-6 col-md-6">
                                            <div className="form-group mb-3">
                                              <label className="uploadLabel mb-2">
                                                {val.FieldName}
                                              </label>
                                              <div className="custom_uploadBtn">
                                                <input
                                                  id={val?.id}
                                                  name="Front"
                                                  type="file"
                                                  accept="image/*"
                                                  // accept={val?.accept}
                                                  onChange={handleFile}
                                                ></input>
                                                {Error?.[val?.id] && (
                                                  <span className="error-msg">
                                                    {Error?.[val?.id]}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            {formValue?.BioMetric?.[val?.id] ?
                                              (
                                                <>
                                                  <p className="uploadLabel mb-2">Preview</p>
                                                  <div className="upload_PreviewImg">
                                                    <img
                                                      src={
                                                        typeof (formValue?.BioMetric?.[val?.id]) == 'string'
                                                          ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.BioMetric?.[val?.id]}`
                                                          : ImgUrl(formValue?.BioMetric?.[val?.id])
                                                      }
                                                      alt="img"
                                                      className="img-fluid"
                                                    />
                                                  </div>
                                                </>
                                              )
                                              :
                                              <></>
                                            }
                                          </div>

                                          {/* <div className="col-lg-6 col-sm-6 col-md-6">
                                            <div className="form-group mb-3">
                                              <label className="uploadLabel mb-2">
                                                {val?.FieldName}
                                              </label>
                                              <div className="custom_uploadBtn">
                                                <input
                                                  id={val?.id}
                                                  name="Back"
                                                  type="file"
                                                  onChange={handleFile}
                                                ></input>
                                                {Error?.AddressProofBack && (
                                                  <span className="error-msg">
                                                    {Error.AddressProofBack}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            {formValue?.BioMetric?.AddressProofBack ? (
                                              <>
                                                <p className="uploadLabel mb-2">Preview</p>
                                                <div className="upload_PreviewImg">
                                                  <img
                                                    src={
                                                      typeof (formValue?.BioMetric?.AddressProofBack) == 'string'
                                                        ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.BioMetric?.AddressProofBack}`
                                                        : ImgUrl(formValue?.BioMetric?.AddressProofBack)
                                                    }
                                                    alt="img"
                                                    className="img-fluid"
                                                  />
                                                </div>
                                              </>
                                            )
                                              :
                                              <></>
                                            }
                                          </div> */}
                                        </>
                                      )
                                      :
                                      (val?.InputType == 'select'
                                        ?
                                        <div className="col-lg-12 col-sm-12">
                                          <div className="form-group mb-4">
                                            <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                            <Select
                                              options={val.Options}
                                              onChange={(e) => OnChange(e, val?.id, "BioMetric")}
                                              value={
                                                isEmpty(formValue?.BioMetric?.[val?.id])
                                                  ?
                                                  {
                                                    label: "Select " + val?.FieldName,
                                                    value: "Select " + val?.FieldName,
                                                  }
                                                  :
                                                  {
                                                    label: formValue?.BioMetric?.[val?.id],
                                                    value: formValue?.BioMetric?.[val?.id],
                                                  }
                                              }
                                            />
                                            {Error?.[val?.id] && (
                                              <span className="error-msg">
                                                {Error[val?.id]}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        :
                                        (
                                          val?.InputType == "PhoneInput"
                                            ?
                                            <div className="col-lg-12 col-sm-12">
                                              <div className="form-group mb-4">
                                                <label className="mb-2 labelname" >{(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}</label>
                                                <PhoneInput
                                                  placeholder={(val?.FirstKey ? val?.FirstKey + " " : "") + val.FieldName}
                                                  id={val?.id}
                                                  className={
                                                    focusedfield?.includes(val?.id)
                                                      ? Error?.[val?.id]
                                                        ? "form-control icon-name is-invalid"
                                                        : "form-control icon-name is-valid"
                                                      : "form-control icon-name"
                                                  }
                                                  onChange={(e) => OnChange(e, val?.id, "BioMetric")}
                                                  // defaultCountry="US"
                                                  // country="US"
                                                  // countries={["US", "IN"]}
                                                  onBlur={(e) => OnBlurFn(e, val?.id, "BioMetric")}
                                                  value={formValue?.BioMetric?.[val?.id] ?? ''}
                                                />
                                                {Error?.[val?.id] && (
                                                  <span className="error-msg">
                                                    {Error[val?.id]}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            :
                                            (val?.InputType == 'Webcam'
                                              ?
                                              <>

                                                <div className="col-lg-6 col-sm-6 col-md-6">
                                                  <div className="form-group mb-3">
                                                    <label className="uploadLabel mb-2">
                                                      {val.FieldName}
                                                    </label>
                                                    <div className="custom_uploadBtn">
                                                      {
                                                        formValue?.BioMetric?.[val?.id]
                                                          ?
                                                          <>
                                                            {!ImgEmpty(formValue?.BioMetric?.[val?.id]) ?
                                                              (
                                                                <>
                                                                  <p className="uploadLabel mb-2">Preview</p>
                                                                  <div className="upload_PreviewImg">
                                                                    <img
                                                                      src={
                                                                        ImgEmpty(formValue?.BioMetric?.[val?.id])
                                                                          ?
                                                                          logocircle
                                                                          : (
                                                                            typeof (formValue?.BioMetric?.[val?.id]) == 'string'
                                                                              ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.BioMetric?.[val?.id]}`
                                                                              : ImgUrl(formValue?.BioMetric?.[val?.id])
                                                                          )
                                                                      }
                                                                      onError={(ev) => ev.target.src = profileCover}
                                                                      alt="img"
                                                                      className="img-fluid"
                                                                    />
                                                                  </div>
                                                                </>
                                                              )
                                                              :
                                                              <></>
                                                            }
                                                            <button
                                                              className="btn btn-brand-lg  font-md-bold mt-2"
                                                              onClick={() => {
                                                                setFormValue({
                                                                  ...formValue,
                                                                  ...{
                                                                    BioMetric: {
                                                                      ...formValue?.BioMetric,
                                                                      [val?.id]: null,
                                                                    }
                                                                  }
                                                                });
                                                              }}
                                                            >
                                                              Recapture
                                                            </button>
                                                          </>
                                                          :
                                                          <>
                                                            <Webcam
                                                              id={"BioMetric" + val?.id + String(ind)}
                                                              screenshotFormat="image/jpeg"
                                                              videoConstraints={videoConstraints}
                                                              audio={false}
                                                              height={500}
                                                              width={500}
                                                              mirrored={true}
                                                            >
                                                              {({ getScreenshot }) => (
                                                                <button
                                                                  className="btn btn-brand-lg  font-md-bold"
                                                                  onClick={() => {
                                                                    const imageSrc = getScreenshot();
                                                                    capture(imageSrc, val?.id, "BioMetric");
                                                                  }}
                                                                >
                                                                  Capture photo
                                                                </button>
                                                              )}
                                                              {/* <button onClick={()=>capture( "BioMetric"+val?.id+String(ind) ,val?.id, "BioMetric")}>Capture photo</button> */}
                                                            </Webcam>
                                                          </>
                                                      }
                                                      {Error?.[val?.id] && (
                                                        <span className="error-msg">
                                                          {Error?.[val?.id]}
                                                        </span>
                                                      )}
                                                    </div>
                                                  </div>

                                                </div>
                                              </>
                                              :
                                              <></>)
                                        )
                                      )
                                  }
                                </>
                              )
                            })
                          }

                          {/* <div className="col-12">
                            <p className="font-md color-grey-500 mb-4">
                              1.) Address Proof
                            </p>
                          </div>
                          <div className="col-lg-6 col-sm-6 col-md-6">
                            <div className="form-group mb-3">
                              <label className="uploadLabel mb-2">
                                Front Image
                              </label>
                              <div className="custom_uploadBtn">
                                <input
                                  id="AddressProofFront"
                                  name="Front"
                                  type="file"
                                  onChange={handleFile}
                                ></input>
                                {Error?.AddressProofFront && (
                                <span className="error-msg">
                                  {Error.AddressProofFront}
                                </span>
                              )}
                              </div>
                            </div>
                            { formValue?.BioMetric?.AddressProofFront ? 
                              (
                                <>
                                  <p className="uploadLabel mb-2">Preview</p>
                                  <div className="upload_PreviewImg">
                                    <img
                                      src={
                                        typeof(formValue?.BioMetric?.AddressProofFront) == 'string' 
                                        ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.BioMetric?.AddressProofFront}`
                                        : ImgUrl(formValue?.BioMetric?.AddressProofFront)
                                      }
                                      alt="img"
                                      className="img-fluid"
                                    />
                                  </div>
                                </>
                              )
                              :
                              <></>
                            }
                          </div>

                          <div className="col-lg-6 col-sm-6 col-md-6">
                            <div className="form-group mb-3">
                              <label className="uploadLabel mb-2">
                                Back Image
                              </label>
                              <div className="custom_uploadBtn">
                                <input
                                  id="AddressProofBack"
                                  name="Back"
                                  type="file"
                                  onChange={handleFile}
                                ></input>
                                {Error?.AddressProofBack && (
                                <span className="error-msg">
                                  {Error.AddressProofBack}
                                </span>
                              )}
                              </div>
                            </div>
                            { formValue?.BioMetric?.AddressProofBack ? (
                              <>
                                <p className="uploadLabel mb-2">Preview</p>
                                <div className="upload_PreviewImg">
                                  <img
                                    src={
                                      typeof(formValue?.BioMetric?.AddressProofBack) == 'string' 
                                      ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.BioMetric?.AddressProofBack}`
                                      : ImgUrl(formValue?.BioMetric?.AddressProofBack)
                                    }
                                    alt="img"
                                    className="img-fluid"
                                  />
                                </div>
                              </>
                            )
                            :
                            <></>
                            }
                          </div>

                          <div className="col-12 mt-4">
                            <p className="font-md color-grey-500 mb-4">
                              2.) National ID card
                            </p>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6">
                            <div className="form-group mb-3">
                              <label className="uploadLabel mb-2">
                                Front Image
                              </label>
                              <div className="custom_uploadBtn">
                                <input
                                  type="file"
                                  id="NationalIdFront"
                                  name="Front"
                                  onChange={handleFile}
                                ></input>
                                {Error?.NationalIdFront && (
                                <span className="error-msg">
                                  {Error.NationalIdFront}
                                </span>
                              )}
                              </div>
                            </div>
                            {
                            formValue?.BioMetric?.NationalIdFront
                            ? (
                              <>
                                <p className="uploadLabel mb-2">Preview</p>

                                <div className="upload_PreviewImg">
                                  <img
                                    src={
                                      typeof(formValue?.BioMetric?.NationalIdFront) == 'string' 
                                      ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.BioMetric?.NationalIdFront}`
                                      : ImgUrl(formValue?.BioMetric?.NationalIdFront)
                                    }
                                    alt="img"
                                    className="img-fluid"
                                  />
                                </div>
                              </>
                              )
                            :
                            <></>
                            }
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-6">
                            <div className="form-group mb-4">
                              <label className="uploadLabel mb-2">
                                Back Image
                              </label>
                              <div className="custom_uploadBtn">
                                <input
                                  type="file"
                                  id="NationalIdBack"
                                  name="Back"
                                  onChange={handleFile}
                                ></input>
                                {Error?.NationalIdBack && (
                                <span className="error-msg">
                                  {Error.NationalIdBack}
                                </span>
                              )}
                              </div>
                            </div>
                            { 
                            formValue?.BioMetric?.NationalIdBack ? (
                              <>
                                <p className="uploadLabel mb-2">Preview</p>

                                <div className="upload_PreviewImg">
                                  <img
                                    src={
                                      typeof(formValue?.BioMetric?.NationalIdBack) == 'string' 
                                      ? `${config.Img_URL}/kyc/${user?._id}/${formValue?.BioMetric?.NationalIdBack}`
                                      : ImgUrl(formValue?.BioMetric?.NationalIdBack)
                                    }
                                    alt="img"
                                    className="img-fluid"
                                  />
                                </div>
                              </>
                            )
                            :
                            <></>
                            }
                          </div> */}

                          {
                            isEmpty(formValue?.BioMetricReject)
                              ?
                              <></>
                              :
                              <div className="col-lg-12 col-sm-12">
                                <div className="form-group mb-4">
                                  <label>Reason for Rejection</label>
                                  <input
                                    className={"form-control icon-email is-invalid"}
                                    type="text"
                                    name="BioMetricReject"
                                    placeholder="Your email"
                                    disabled={true}
                                    id="BioMetricReject"
                                    value={formValue?.BioMetricReject || ""}
                                  />
                                </div>
                              </div>
                          }
                          <div className="row align-items-center mt-30 mt-4">
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                              <div className="form-group">
                                <button
                                  className="btn btn-brand-lg btn-full font-md-bold"
                                  type="button"
                                  //   onClick={() => Register()}
                                  onClick={() => GoBack(step)}
                                >
                                  Back
                                </button>
                              </div>
                            </div>
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                              <div className="form-group">
                                <button
                                  className="btn btn-brand-lg btn-full font-md-bold"
                                  type="button"
                                  onClick={() => Register("submit")}
                                // onClick={() => handleStep(step)}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </section>

        <Subscriber />
        {/* <div className="box-newsletter">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 mt-3 col-md-12">
                                <div className="box-image-newsletter">
                                    <div className="">
                                        <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                                        <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mt-3">
                                <span className="font-lg color-brand-1">Newsletter</span>
                                <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                                <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                                <div className="form-newsletter mt-3 position-relative">
                                    <form action="" className="newsletter-form" novalidate="novalidate">

                                        <input type="email" name="email" placeholder="Enter your email..." />
                                        <button className="btn btn-submit-newsletter" type="submit">
                                            <FaArrowRight />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

        <Footer />
      </div>
    </>
  );
}
